import React from 'react';
import { Table, Pagination } from "antd";
import { t } from "i18next";

export default function CustomTableScroll(props) {
    return (
        <div>
            <Table columns={props.columns} dataSource={props.data} pagination={false} scroll={{x:2000}} />
            <div className="h-11 flex items-center justify-end bg-[#EAEAEA] border-t-[#EAEAEA] border-solid rounded-b-xl px-[30px] py-[8px]">

                {
                    props.showPagination ? (
                        <div className='flex items-center justify-end'>
                            <p>{t("USER:VIEW_PER_PAGE")}</p>
                            <Pagination defaultCurrent={1} total={props.data?.length} showSizeChanger />
                        </div>
                    ) : null
                }
            </div>
        </div>
    );
}